module.exports = __webpack_public_path__ + "static/media/Entrerios.ad6ada17.svg";